<template>
  <SectionLayout
    v-if="renderComponent"
    class="insurance-process-section"
    :title="sectionTitle"
    bg-theme="primary-invert"
    ref="sectionRef"
    :step="step"
  >
    <InsuranceExecution @cancel-subscription="showModalSubsciptionCancel = true"
                        @payment-link-sent="onPaymentLinkSent"
                        @close="onClose"
                        @change-step="changeStep"
    />
  </SectionLayout>
</template>

<script>
import SectionLayout from '@/components/layouts/SectionLayout';
import InsuranceTariffsList from '@/components/pages/index/InsuranceProcess/InsuranceTariffsList';
import InsuranceExecution from '@/components/pages/index/InsuranceProcess/InsuranceExecution';
import ModalSubscriptionCancel from '@/components/modals/ModalSubscriptionCancel';
import ModalPaymentLinkWasSent from '@/components/modals/ModalPaymentLinkWasSent';

export default {
  name: 'InsuranceProcess',
  components: {
    SectionLayout,
    InsuranceTariffsList,
    InsuranceExecution,
    ModalSubscriptionCancel,
    ModalPaymentLinkWasSent
  },
  data() {
    return {
      renderComponent: true,
      step: 1,
      showModalSubsciptionCancel: false,
      showModalPaymentLinkWasSent: false
    }
  },
  props: [
    'showModalSubsciptionCancel',
  ],
  methods: {
    changeStep(step) {
      if (step === 'define-inn') {
        this.step = 1;
      } else if (step === 'client-details') {
        this.step = 1;
      } else if (step === 'property-details') {
        this.step = 1;
      } else if (step === 'sum-result') {
        this.step = 2;
      } else if (step === 'payment') {
        this.step = 3;
      }
    },
    closeCancelModal() {
      this.showModalSubsciptionCancel = false;
      this.$emit('close-cancel-modal');
    },
    onPaymentLinkSent() {
      this.resetComponent();
      this.showModalPaymentLinkWasSent = true;
    },
    async resetComponent() {
      this.renderComponent = false;
      await this.$nextTick();
      this.renderComponent = true;
    },
    onClose() {
      this.step = 1;
      this.scrollToSectionTop();
    },
    scrollToSectionTop() {
      if (this.$refs?.sectionRef?.$el) {
        this.$refs.sectionRef.$el.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    }
  },
  computed: {
    sectionTitle() {
      switch (this.step) {
        case 1:
          return 'Страхование ОСГОП онлайн';
        case 2:
          return 'Страхование ОСГОП онлайн';
        case 3:
          return 'Страхование ОСГОП онлайн';
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.insurance-process-section {
}
</style>